import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {IShard} from "../../company-create/models/shard";
import {ServerEndpoints} from "../../../../server.endpoints";

@Injectable({
  providedIn: 'root'
})
export class ShardHttpService {

  constructor(private http: HttpClient, @Inject("BASE_URL") private base: string) {
  }

  load(id: string): Observable<IShard> {
    return this.http.get<IShard>(`${this.base}${ServerEndpoints.Management_Shard_$id$_v2025_4.dictReplace({id: id})}`);
  }

  upsert(shard: IShard): Observable<IShard> {
    return this.http.put<IShard>(`${this.base}${ServerEndpoints.Management_Shard__v2025_4}`, shard);
  }
}
